import AnalysisDataIcon from "@/components/atoms/svg/icons/AnalysisDataIcon";
import BookIcon from "@/components/atoms/svg/icons/BookIcon";
import BusinessIcon from "@/components/atoms/svg/icons/BusinessIcon";
import CartIcon from "@/components/atoms/svg/icons/CartIcon";
import ChartIcon from "@/components/atoms/svg/icons/ChartIcon";
import { default as ChatBotIcon } from "@/components/atoms/svg/icons/ChatBotIcon";
import ChatSmileIcon from "@/components/atoms/svg/icons/ChatSmileIcon";
import ClockIcon from "@/components/atoms/svg/icons/ClockIcon";
import CopyIcon from "@/components/atoms/svg/icons/CopyIcon";
import { default as DashBoardIcon } from "@/components/atoms/svg/icons/DashBoardIcon";
import DatabaseIcon from "@/components/atoms/svg/icons/DatabaseIcon";
import DeepseekIcon from "@/components/atoms/svg/social/DeepseekIcon";
import DeleteIcon from "@/components/atoms/svg/icons/DeleteIcon";
import DesignIcon from "@/components/atoms/svg/icons/DesignIcon";
import EmailIcon from "@/components/atoms/svg/icons/EmailIcon";
import FavoriteIcon from "@/components/atoms/svg/icons/FavoriteIcon";
import FlowIcon from "@/components/atoms/svg/icons/FlowIcon";
import GridIcon from "@/components/atoms/svg/icons/GridIcon";
import HealthIcon from "@/components/atoms/svg/icons/HealthIcon";
import HealthyIcon from "@/components/atoms/svg/icons/HealthyIcon";
import LanguageIcon from "@/components/atoms/svg/icons/LanguageIcon";
import ListIcon from "@/components/atoms/svg/icons/ListIcon";
import MicroshipActiveIcon from "@/components/atoms/svg/icons/MicroshipActiveIcon";
import MicroshipIcon from "@/components/atoms/svg/icons/MicroshipIcon";
import NoteIcon from "@/components/atoms/svg/icons/NoteIcon";
import ProgrammingIcon from "@/components/atoms/svg/icons/ProgrammingIcon";
import SEOIcon from "@/components/atoms/svg/icons/SEOIcon";
import SettingIcon from "@/components/atoms/svg/icons/SettingIcon";
import SettingListIcon from "@/components/atoms/svg/icons/SettingListIcon";
import TeamIcon from "@/components/atoms/svg/icons/TeamIcon";
import WalletIcon from "@/components/atoms/svg/icons/WalletIcon";
import ChatGPTIcon from "@/components/atoms/svg/social/ChatGPTIcon";
import ChatGPTIcon6 from "@/components/atoms/svg/social/ChatGPTIcon6";
import CopilotIcon from "@/components/atoms/svg/social/CopilotIcon";
import GeminiIcon from "@/components/atoms/svg/social/GeminiIcon";
import MistralAiIcon from "@/components/atoms/svg/social/MistralAiIcon";
import ClaudeIcon from "@/components/atoms/svg/social/ClaudeIcon";
import TelegramIconFlat from "@/components/atoms/svg/social/TelegramIconFlat";
import TwitterIcon from "@/components/atoms/svg/social/TwitterIcon";
import EyeCloseIcon from "@/components/atoms/svg/icons/EyeCloseIcon";
import EmojiPlusIcon from "@/components/atoms/svg/icons/EmojiPlusIcon";
import MetaIcon from "@/components/atoms/svg/social/MetaIcon";
import {
  BedIcon,
  CalendarIcon,
  DogIcon,
  ListFilter,
  TvIcon,
} from "lucide-react";

export const MENU_ICON_MICROSHIP = (fill?: string, fillOpacity?: string) => (
  <MicroshipIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_MICROSHIP_ACTIVE = (fill?: string) => (
  <MicroshipActiveIcon fill={fill} />
);
export const MENU_ICON_BOOK = (fill?: string, fillOpacity?: string) => (
  <BookIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_FAVORITE = (fill?: string, fillOpacity?: string) => (
  <FavoriteIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_SETTING = (fill?: string, fillOpacity?: string) => (
  <SettingIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_NOTE = (fill?: string, fillOpacity?: string) => (
  <NoteIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_CLOCK = (fill?: string, fillOpacity?: string) => (
  <ClockIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_HEALTH = (fill?: string, fillOpacity?: string) => (
  <HealthIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_FLOW = (fill?: string, fillOpacity?: string) => (
  <FlowIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_CHAT_BOT = (fill?: string, fillOpacity?: string) => (
  <ChatBotIcon fill={fill} fillOpacity={fillOpacity} />
);
export const MENU_ICON_DASHBOARD = (fill?: string, fillOpacity?: string) => (
  <DashBoardIcon fill={fill} fillOpacity={fillOpacity} />
);

// CATEGORIES
export const TAG_ICON_BUSINESS = (fill?: string, fillOpacity?: string) => (
  <BusinessIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_ANALYSIS = (fill?: string, fillOpacity?: string) => (
  <AnalysisDataIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_HEALTHY = (fill?: string, fillOpacity?: string) => (
  <HealthyIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_EMAIL = (fill?: string, fillOpacity?: string) => (
  <EmailIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_DESIGN = (fill?: string, fillOpacity?: string) => (
  <DesignIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_MARKETING = (fill?: string, fillOpacity?: string) => (
  <CartIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_PROGRAMMING = (fill?: string, fillOpacity?: string) => (
  <ProgrammingIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_SEO = (fill?: string, fillOpacity?: string) => (
  <SEOIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_LANGUAGE = (fill?: string, fillOpacity?: string) => (
  <LanguageIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TAG_ICON_LIST = (fill?: string, fillOpacity?: string) => (
  <ListIcon fill={fill} fillOpacity={fillOpacity} />
);

// SOCIAL
export const AI_CHATGPT = () => <ChatGPTIcon className="w-full h-full" />;
export const AI_CHATGPT6_1 = () => <ChatGPTIcon6 className="w-full h-full" />;
export const AI_MISTRAL_AI = () => <MistralAiIcon className="w-full h-full" />;
export const AI_GEMINI = () => <GeminiIcon className="w-full h-full" />;
export const AI_COPILOT = () => <CopilotIcon className="w-full h-full" />;
export const AI_DEEPSEEK_ICON = () => <DeepseekIcon />;
export const AI_CLAUDE_ICON = () => <ClaudeIcon />;
export const AI_META_ICON = () => <MetaIcon />;

// MENU ACTION
export const MENU_ACTION_PUBLISHED = () => (
  <EmojiPlusIcon fill="#0F132499" width={24} height={24} fillOpacity={1} />
);
export const MENU_ACTION_UNPUBLISHED = () => <EyeCloseIcon fill="#0F132499" />;
export const MENU_ACTION_COPY = () => <CopyIcon className="w-full h-full" />;
export const MENU_ACTION_DELETE = () => (
  <DeleteIcon className="w-full h-full" />
);

// SLIDER CONTENT
export const WALLET_ICON = (fill?: string, fillOpacity?: string) => (
  <WalletIcon fill={fill} fillOpacity={fillOpacity} />
);
export const TEAM_ICON = (fill?: string, fillOpacity?: string) => (
  <TeamIcon fill={fill} fillOpacity={fillOpacity} />
);
export const CHAT_SMILE_ICON = (fill?: string, fillOpacity?: string) => (
  <ChatSmileIcon fill={fill} fillOpacity={fillOpacity} />
);
export const DATABASE_ICON = (fill?: string, fillOpacity?: string) => (
  <DatabaseIcon fill={fill} fillOpacity={fillOpacity} />
);
export const SETTING_LIST_ICON = (fill?: string, fillOpacity?: string) => (
  <SettingListIcon fill={fill} fillOpacity={fillOpacity} />
);
export const CHART_ICON = (fill?: string, fillOpacity?: string) => (
  <ChartIcon fill={fill} fillOpacity={fillOpacity} />
);
export const GRID_ICON = (fill?: string, fillOpacity?: string) => (
  <GridIcon fill={fill} fillOpacity={fillOpacity} />
);

// SOCIAL CONTACT
export const X_TWITTER = () => (
  <TwitterIcon className="w-full h-full fill-[#BABDC5]" />
);
export const TELEGRAM = () => (
  <TelegramIconFlat className="w-full h-full !fill-[#BABDC5]" />
);

// GROUPICON

export const ICON_FILTERLIST = <ListFilter className="w-4 h-4" />;
export const ICON_CERLENDAR = <CalendarIcon className="w-4 h-4" />;
export const ICON_TV = <TvIcon className="w-4 h-4" />;
export const ICON_BED = <BedIcon className="w-4 h-4" />;
export const ICON_DOG = <DogIcon className="w-4 h-4" />;
